export enum ZIndexLayer {
  AlertBox = 1700,
  AppBar = 1300,
  AppTooltip = 1100,
  ArticleAuthorFollowButton = 1001,
  Drawer = 1400,
  DropdownSelect = 1350,
  EditionInvitation = 1900,
  GoogleOneTapSignIn = 2000,
  HamburgerMenu = 1800,
  LiveUpdateAlert = 4000,
  Modal = 1500,
  NewsletterArticleFloatingWidget = 1000,
  NewsletterArticleIssues = 1200,
  OnboardingDialog = 3000,
  PlusDatePicker = 1202,
  PlusListingPopup = 2200,
  PlusPopup = 2100,
  SnackBar = 1600,
  StoryCardCarouselWidget = 1102,
  TakeoverAd = 1101,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Tooltip = 1700,
}
